<template>
  <div>
    <h3 class="text-center font-weight-bold title">Сертификат объекта</h3>
    <br />

    <h6 class="text-left font-weight-bold subtitle">Информация о поиске</h6>
    <br />
    <table style="width: 100%">
      <tr v-if="getSearchTerm" class="row">
        <td class="col-3 font-weight-bold subline">Поиск</td>
        <td class="col-9 text">{{ getSearchTerm }}</td>
      </tr>
      <tr v-if="getCreatedAt" class="row">
        <td class="col-3 font-weight-bold subline">Дата создания</td>
        <td class="col-9 text">{{ getCreatedAt }}</td>
      </tr>
      <tr v-if="getCreatedBy" class="row">
        <td class="col-3 font-weight-bold subline"><strong>ФИО</strong></td>
        <td class="col-9 text">{{ getCreatedBy() }}</td>
      </tr>
      <tr v-if="getCountryCodes" class="row">
        <td class="col-3 font-weight-bold subline">Страны</td>
        <td class="col-9 text">{{ getCountryCodes }}</td>
      </tr>
      <tr v-if="getFuzziness" class="row">
        <td class="col-3 font-weight-bold subline">Нечеткость</td>
        <td class="col-9 text">{{ getFuzziness }}%</td>
      </tr>
      <tr v-if="getEnt" class="row">
        <td class="col-3 font-weight-bold subline">Тип объекта</td>
        <td class="col-9 text">{{ getEnt }}</td>
      </tr>
    </table>
    <br />

    <h6 class="text-left font-weight-bold subtitle">Ключевая информация</h6>
    <br />

    <table style="width: 100%">
      <tr class="row">
        <td class="col-3 font-weight-bold subline"><strong>ФИО</strong></td>
        <td class="col-9 text">{{ hit.doc.name }}</td>
      </tr>
    </table>
    <br />
    <table style="width: 100%">
      <tr class="row">
        <td class="col-3 font-weight-bold subline">
          <strong>Тип объекта</strong>
        </td>
        <td class="col-9 text">{{ getEntityName(hit.doc.entity_type) }}</td>
      </tr>
    </table>
    <br />
    <table style="width: 100%">
      <tr class="row">
        <td class="col-3 font-weight-bold subline">
          <strong>Другие названия</strong>
        </td>
        <td class="col-9 text">{{ hit.doc.aka.map((a) => a.name).join() }}</td>
      </tr>
    </table>

    <br />
    <table style="width: 100%">
      <tr class="row">
        <td class="col-3 font-weight-bold subline"><strong>Страны</strong></td>
        <td class="col-9 text">{{ getCountries(hit.doc.fields) }}</td>
      </tr>
    </table>
    <table style="width: 100%">
      <tr class="row">
        <td class="col-3 font-weight-bold subline">
          <strong>Дата рождения</strong>
        </td>
        <td class="col-9 text">{{ getDateOfBirth(hit.doc.fields) }}</td>
      </tr>
    </table>
    <br />

    <h6 class="text-left font-weight-bold subtitle">Листинг</h6>
    <br />
    <div v-for="note in hit.doc.source_notes">
      <table style="width: 100%" v-if="note.aml_types[0] == 'adverse-media'">
        <tr class="row">
          <td class="col-2">
            <a
              :href="note.url"
              class="badge badge-pill badge-warning text-wrap"
              >{{ getResponseType(note.aml_types[0]) }}</a
            >
          </td>

          <td class="col-9 subtitle">{{ note.name }}</td>
          <td class="col-1"></td>
        </tr>
        <tr class="row">
          <td class="col-2"></td>
          <td class="col-3 subline">Страны</td>
          <td class="col-7" v-if="note.country_codes">
            {{ note.country_codes.join(", ") }}
          </td>
          <td v-else></td>
        </tr>
        <tr class="row">
          <td class="col-2"></td>
          <td class="col-3 subline">Подтипы нежелательных медиа</td>
          <td class="col-7">{{ getResponseTypes(note.aml_types.slice(1)) }}</td>
        </tr>
        <tr class="row">
          <td class="col-2"></td>
          <td class="col-3 subline">Связанный URL</td>
          <td class="col-7">
            <a :href="note.url" rel="noopener noreferrer" target="_blank">{{
              note.url
            }}</a>
          </td>
        </tr>
        <br />
      </table>

      <table style="width: 100%" v-else>
        <tr class="row">
          <td class="col-2">
            <p hidden></p>
            <a :href="note.url" class="badge badge-pill badge-warning">{{
              getResponseType(note.aml_types[0])
            }}</a>
          </td>
          <td class="col-10 subtitle" colspan="2">{{ note.name }}</td>
        </tr>

        <tr class="row">
          <td class="col-2"></td>
          <td class="col-3 subline">Дата назначения</td>
          <td class="col-7">{{ note.listing_started_utc }}</td>
        </tr>
        <tr class="row">
          <td class="col-2"></td>
          <td class="col-3 subline">Связанный URL</td>
          <td class="col-7">
            <a :href="note.url" rel="noopener noreferrer" target="_blank">{{
              note.url
            }}</a>
          </td>
        </tr>
      </table>
      <br />
    </div>

    <h6 class="text-left font-weight-bold subtitle">Медиа</h6>
    <br />
    <div style="width: 100%" v-for="mds in grouped_media()" class="row">
      <div
        v-for="media in mds"
        class="col-lg-6 d-flex align-items-stretch"
        style="padding-top: 10px"
      >
        <div>
          <div class="row">
            <div class="col-12">
              <h6 class="font-weight-bold subtitle">
                <a
                  :href="media.url"
                  rel="noopener noreferrer"
                  target="_blank"
                  >{{ media.title }}</a
                >
              </h6>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <small>({{ momentum(media.date) }})</small>
            </div>
          </div>

          <div class="row">
            <div class="col-12 text">{{ media.snippet }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: ["user_id", "doc_id", "doc", "goods", "doc_additional"],
  data() {
    return {
      aml: [],
      person: {
        given_name: "",
        last_name: "",
      },
    };
  },
  mounted() {
    //console.log('aml pdf doc_additional', this.doc_additional);
    // moment.locale(this.i18n.locale=='cn'?'zh-cn':'ru', this.i18n.locale=='cn'?zh:ru);
    moment.locale("ru");
    // setTimeout(()=>{
    // 	this.$root.$emit('print-pdf', {signature: '', type: 'aml'})
    // }, 2000)
    axios.get(window.base + "/document/getfirmfull").then((response) => {
      this.person = response.data.persons;
    });
  },
  methods: {
    getCreatedBy() {
      return this.person.last_name + " " + this.person.given_name;
    },
    /**
     * proxy to call external function in template
     */

    number_to_letters(val) {
      if (this.$i18n.locale == "en") return window.number_to_letters_en(val);
      else return window.number_to_letters(val);
    },
    getEntityName(entity) {
      return this.$t(
        "message.comply_advantage.response_entity_type_" + entity.trim(),
      );
    },
    grouped_media() {
      return _.chunk(this.hit.doc.media, 2);
    },
    hitSourceName(str) {
      if (typeof this.hit.doc.source_notes[str] !== "undefined")
        return this.hit.doc.source_notes[str].name;
      return "";
    },

    isValidUrl(str) {
      var a = document.createElement("a");
      a.href = str;
      return a.host && a.host != window.location.host;
    },
    momentum(d) {
      return moment(d).format("D.MM.Y");
    },
    /**
     * proxy to call external function in template
     */
    days_to_letters(val) {
      if (this.$i18n.locale == "en") return window.days_to_letters_en(val);
      else return window.days_to_letters(val);
    },
    /**
     * proxy to call external function in template
     */
    money_letters(val, cur) {
      if (this.$i18n.locale == "en") return window.money_letters_en(val, cur);
      else return window.money_letters(val, cur);
    },
    /**
     * proxy to call external function in template
     */
    percent_to_letters(val) {
      if (this.$i18n.locale == "en") return window.percent_to_letters_en(val);
      else return window.percent_to_letters(val);
    },
    getCountries(fields) {
      fields = fields.filter((field) => field.name.trim() === "Countries");
      fields = fields.map((field) => {
        return field.value;
      });
      return fields[0];
    },
    getNames(aka) {
      //fields = fields.filter(field => field.name.trim() === 'Countries')
      aka = aka.map((field) => {
        return field.name;
      });
      return aka[0];
    },
    getDateOfBirth(fields) {
      var dobs = fields.filter(
        (field) => field.name.trim() === "Date of Birth",
      );
      if (typeof dobs[0] != "undefined") return dobs[0].value;
      else return "";
    },
    getResponseTypes(types) {
      return types
        .map((type) => {
          return this.$t(
            "message.comply_advantage.response_match_" + type.trim(),
          );
        })
        .join(",");
    },
    getResponseType(type) {
      return this.$t("message.comply_advantage.response_match_" + type.trim());
    },
  },
  watch: {},
  computed: {
    hit() {
      if (
        this.doc !== false &&
        typeof this.doc.content.data.hits[0] !== "undefined"
      )
        return this.doc.content.data.hits[0];
      return {};
    },
    getFuzziness() {
      if (typeof this.doc_additional !== "undefined") {
        if (typeof this.doc_additional.fuzziness !== "undefined")
          return parseFloat(this.doc_additional.fuzziness) * 100;
      }

      return false;
    },
    getSearchTerm() {
      if (typeof this.doc_additional !== "undefined") {
        if (typeof this.doc_additional.search_term !== "undefined")
          return this.doc_additional.search_term;
      }
      return false;
    },
    getCreatedAt() {
      if (typeof this.doc !== "undefined") {
        if (typeof this.doc.content !== "undefined")
          if (typeof this.doc.content.data !== "undefined")
            if (typeof this.doc.content.data.created_at !== "undefined")
              return this.momentum(this.doc.content.data.created_at);
      }
      return false;
    },
    getCountryCodes() {
      if (typeof this.doc_additional !== "undefined") {
        if (typeof this.doc_additional.country_codes !== "undefined")
          return this.doc_additional.country_codes.join(", ");
      }
      return false;
    },
    getEnt() {
      if (typeof this.doc_additional !== "undefined") {
        if (typeof this.doc_additional.entity_type !== "undefined")
          return this.getEntityName(this.doc_additional.entity_type);
      }
      return false;
    },
  },
};
</script>
<style scoped>
.title {
  line-height: 1.5 !important;
  color: black;
  font-weight: 500 !important;
}
.subline {
  line-height: 1.2 !important;
  font-size: 14px;
  font-weight: 400 !important;
  color: #37517e;
}
.subtitle {
  font-size: 16px;
  font-weight: 500 !important;
  color: black;
}
.text {
  font-size: 14px;
  color: black;
}
.html2pdf__page-break {
  page-break-before: always;
}
</style>
